<template>
  <div class="py-3">
    <div
      ref="videogrid"
      class="row"
    >
      <div
        v-for="(video, index) in videoData"
        :key="video.url"
        class="col-md-6 col-lg-4 mb-4 "
        @click="openVideo(index)"
        @keydown.esc="closeVideo('video-' + index)"
        @keydown.enter="openVideo(index)"
        role="link"
        tabindex="0"
        :aria-label="
          'Click or press enter to play the video titled, ' + video.title
        "
        :id="'video-' + index"
      >
        <div
          class="video-thumb embed-responsive embed-responsive-16by9 d-flex drop-shadow-lg bg-primary"
          :style="'background-image: url(' + (video.photo ? video.photo.sizes.medium : 'https://img.youtube.com/vi/' + video.youtube_code + '/maxresdefault.jpg') + ')'"
        >
          <div class="w-100 d-flex mt-auto align-items-center justify-content-between p-4">
            <div class="btn btn-outline-light rounded-pill font-weight-bold flex-none ml-auto flex justify-content-center align-items-center text-white" style="font-size: .8em; background-color:rgba(0,0,0,.5)" >
              <span class="uppercase font-weight-bold pr-2">Play</span><i class="fa fa-play" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <p
          class="text-primary filter drop-shadow opacity-90 font-bold leading-tight tracking-wide text-xl font-weight-bold block p-2 m-0"
          v-html="video.title"
          tabindex="0"
        ></p>
      </div>
    </div>
    <portal to="popup-target">
      <div
        v-if="popupOpen"
        class="popup"
      >
        <div class="position-relative w-100 h-100 flex flex-column py-5 px-lg-5 mx-auto" style="max-width:1400px;">

          <div
            id="videopop"
            tabindex="0"
            class="w-100 embed-responsive embed-responsive-16by9"
            @keydown.esc="closeVideo('video-' + activeIndex)"
            @keydown.arrowright="nextVideo"
            @keydown.arrowleft="prevVideo"
          >
            <iframe
              onload="this.contentWindow.focus()"
              tabindex="0"
              :title="videoData[activeIndex].title"
              class="embed-responsive-item border border-primary"
              :src="
                'https://www.youtube-nocookie.com/embed/' +
                videoData[activeIndex].youtube_code +
                '?autoplay=1&rel=0&showinfo=0'
              "
              allow="autoplay; encrypted-media"
              frameborder="0"
              allowfullscreen="allowfullscreen"
              @keydown.esc="closeVideo('video-' + activeIndex)"
              @keydown.arrowright="nextVideo"
              @keydown.arrowleft="prevVideo"
            ></iframe>
          </div>

          <div
            class="relative py-4 d-flex flex-wrap justify-content-center align-items-center my-1"
          >
            <button
              v-if="videoData.length > 1"
              @click="prevVideo"
              class="btn btn-outline-primary rounded-pill my-1"
            >
              <i class="fa fa-play mr-1" aria-hidden="true" style="transform: rotate(180deg)"></i>
              previous <span class="sr-only" >video</span>
            </button>
            <span v-if="videoData.length > 1" class="text-primary d-inline-block font-bold flex items-center leading-none px-2 my-1">
              {{ activeIndex + 1 }} of {{ videoData.length }}</span
            >
            <button
              v-if="videoData.length > 1"
              @click="nextVideo"
              class="btn btn-outline-primary rounded-pill my-1"
            >
              next <span class="sr-only" >video</span>
              <i class="fa fa-play ml-1" aria-hidden="true"></i>
            </button>
            <button
              @click="closeVideo('video-' + activeIndex)"
              class="btn btn-primary mx-4 rounded-pill px-4 my-1"
            >
              close
            </button>
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
export default {
  name: "VideoFeed",

  props: {
    videos: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeVideo: {},
      videoData: [],
      popupOpen: false,
      activeIndex: 0,
    };
  },

  mounted() {
    this.videoData = this.videos;
  },

  methods: {
    openVideo(num) {
      this.popupOpen = true;
      this.activeIndex = num;
      this.activeVideo = this.videoData[num];
      this.$nextTick(() => {
        document.getElementById("videopop").focus();
      });
    },

    closeVideo(target = "videogrid") {
      this.popupOpen = false;
      this.$nextTick(() => {
        document.getElementById(target).focus();
      });
    },

    nextVideo() {
      if (this.activeIndex + 1 == this.videoData.length) {
        this.activeIndex = 0;
      } else {
        this.activeIndex++;
      }

      this.openVideo(this.activeIndex);
    },

    prevVideo() {
      if (this.activeIndex + 1 == 1) {
        this.activeIndex = this.videoData.length;
      } else {
        this.activeIndex--;
      }

      this.openVideo(this.activeIndex);
    },
  },
};
</script>
